import commonService from "../service/commonService.js";
import { Toast,Indicator} from "mint-ui";
export default {
    methods: {
        changeTitle(title) {
            this.$emit("changeTitle", title);
        },
        isPhone() {
            return commonService.isPhone();
        },
        showFeatures(features){
            
        }
    },
    mounted() {
        Indicator.close();
    },
};


// WEBPACK FOOTER //
// ./src/mixin/changeTitle.js